import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const FadeUp = ({
  children,
  delay = 0,
  y = 30,
  duration = 0.85,
  className = "",
  amount = 0.25,
  ...rest
}) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount }}
    transition={{ duration, delay, ease: EASE }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, center = false, className = "" }) => (
  <p
    className={`flex items-center gap-3 text-[10px] font-medium uppercase tracking-[0.34em] text-champagne sm:text-[11px] ${
      center ? "justify-center" : ""
    } ${className}`}
  >
    <span className="inline-block h-[5px] w-[5px] rotate-45 bg-champagne/90" aria-hidden="true" />
    {children}
  </p>
);

export const GoldDiamond = ({ className = "" }) => (
  <span
    className={`inline-block h-2 w-2 rotate-45 border border-champagne/80 ${className}`}
    aria-hidden="true"
  />
);

export const SectionIntro = ({ eyebrow, title, subtitle, center = true }) => (
  <div className={center ? "text-center" : ""}>
    <FadeUp>
      <Eyebrow center={center}>{eyebrow}</Eyebrow>
    </FadeUp>
    <FadeUp delay={0.1}>
      <h2 className="mt-6 font-serif text-3xl font-medium leading-[1.12] tracking-[-0.01em] text-ivory sm:text-4xl lg:text-[44px]">
        {title}
      </h2>
    </FadeUp>
    {subtitle && (
      <FadeUp delay={0.2}>
        <p
          className={`mt-5 max-w-xl text-sm font-light leading-relaxed text-ivory-muted sm:text-base ${
            center ? "mx-auto" : ""
          }`}
        >
          {subtitle}
        </p>
      </FadeUp>
    )}
  </div>
);
